import { isEmpty } from 'lodash';
import {
  CreateParams,
  CreateResult,
  DeleteParams,
  DeleteResult,
  GetListParams,
  GetListResult,
  GetOneParams,
  GetOneResult,
  UpdateParams,
  UpdateResult,
} from 'react-admin';
import { getClientApi } from 'src/data-communication';
import {
  SortDirectionTypeDto,
  PrivateQuoteDto,
  CreatePrivateQuoteBodyDto,
  GetPrivateQuoteListSortByQueryParamTypeDto,
  PatchPrivateQuoteBodyDto,
} from 'src/dtos';

const clientApi = getClientApi();

export const getPrivateQuoteList = async (params: GetListParams): Promise<GetListResult<PrivateQuoteDto>> => {
  const { data, total } = await clientApi.privateQuote.list({
    queryParams: {
      skip: params.meta?.skipPagination ? undefined : params.pagination.perPage * (params.pagination.page - 1),
      take: params.meta?.skipPagination ? undefined : params.pagination.perPage,
      filterBy: isEmpty(params.filter) ? undefined : params.filter,
      sortDirection: params.sort?.order?.toLowerCase() as SortDirectionTypeDto,
      sortBy: params.sort?.field as GetPrivateQuoteListSortByQueryParamTypeDto,
    },
  });

  return {
    data,
    total,
  };
};

export const getPrivateQuote = async (params: GetOneParams): Promise<GetOneResult<PrivateQuoteDto>> => {
  const { id } = params;

  const data = await clientApi.privateQuote.retrieve({ params: { id } });

  return {
    data,
  };
};

export const createPrivateQuote = async (
  params: CreateParams<CreatePrivateQuoteBodyDto>,
): Promise<CreateResult<PrivateQuoteDto>> => {
  const data = params.data as CreatePrivateQuoteBodyDto;
  const result = await clientApi.privateQuote.create({ body: data });

  return {
    data: result,
  };
};

export const patchPrivateQuote = async (
  params: UpdateParams<PatchPrivateQuoteBodyDto & { id: string }>,
): Promise<UpdateResult<PrivateQuoteDto>> => {
  const { id } = params;

  const data = await clientApi.privateQuote.patch({ params: { id }, body: params.data });

  return {
    data,
  };
};

export const deletePrivateQuote = async (params: DeleteParams): Promise<DeleteResult<PrivateQuoteDto>> => {
  const { id, previousData } = params;

  await clientApi.privateQuote.delete({ params: { id } });

  return {
    data: { ...previousData },
  };
};
